module.exports = __webpack_public_path__ + "img/ae82b18.png";